// Strings only the web client needs (no Apple/Android counterpart). Same rule as the generated
// tables: every key in BOTH languages. Keys are prefixed `web.` so they never collide with a key
// the native tables add later.
export const webStrings: { es: Record<string, string>; en: Record<string, string> } = {
  es: {
    'web.otherTab.title': 'Satori Chat está abierto en otra pestaña',
    'web.otherTab.body': 'Solo una pestaña puede usar el chat a la vez, para que tus mensajes y avisos no se dupliquen.',
    'web.otherTab.useHere': 'Usar aquí',
    'web.storage.memoryOnly': 'Este navegador no permite guardar el chat en el equipo; se cargará de nuevo al recargar la página.',
    'web.boot.loading': 'Abriendo Satori Chat…',
    'web.menu.appearance': 'Apariencia',
    'web.theme.system': 'Igual que el sistema',
    'web.theme.light': 'Claro',
    'web.theme.dark': 'Oscuro',
    'web.login.lede': 'Entra con tu cuenta de la empresa.',
  },
  en: {
    'web.otherTab.title': 'Satori Chat is open in another tab',
    'web.otherTab.body': 'Only one tab can use the chat at a time, so your messages and notifications are never doubled.',
    'web.otherTab.useHere': 'Use here',
    'web.storage.memoryOnly': 'This browser does not allow saving the chat on this computer; it will load again after a reload.',
    'web.boot.loading': 'Opening Satori Chat…',
    'web.menu.appearance': 'Appearance',
    'web.theme.system': 'Same as the system',
    'web.theme.light': 'Light',
    'web.theme.dark': 'Dark',
    'web.login.lede': 'Sign in with your company account.',
  },
};
